// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorQuotes = (client) => ({
    /**
     * `POST /vendor/quotes/:id/items`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateQuoteItems
     * @source apps/backend/src/api/vendor/quotes/[id]/items/route.ts
     */
    createItem: (id, body, query, headers) => client.fetch(buildPath("/vendor/quotes/:id/items", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/quotes/:id/messages`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateQuoteMessage
     * @source apps/backend/src/api/vendor/quotes/[id]/messages/route.ts
     */
    createMessage: (id, body, query, headers) => client.fetch(buildPath("/vendor/quotes/:id/messages", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/quotes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListQuotes
     * @source apps/backend/src/api/vendor/quotes/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/quotes", { method: "GET", query, headers }),
    /**
     * `GET /vendor/quotes/:id/preview`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetQuotePreview
     * @source apps/backend/src/api/vendor/quotes/[id]/preview/route.ts
     */
    preview: (id, query, headers) => client.fetch(buildPath("/vendor/quotes/:id/preview", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/quotes/:id/reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorRejectQuote
     * @source apps/backend/src/api/vendor/quotes/[id]/reject/route.ts
     */
    reject: (id, body, query, headers) => client.fetch(buildPath("/vendor/quotes/:id/reject", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/quotes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetQuote
     * @source apps/backend/src/api/vendor/quotes/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/quotes/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/quotes/:id/send`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSendQuote
     * @source apps/backend/src/api/vendor/quotes/[id]/send/route.ts
     */
    send: (id, body, query, headers) => client.fetch(buildPath("/vendor/quotes/:id/send", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=quotes.js.map